// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"234":"c1979250","359":"f41fa38b","361":"abf77000"}[chunkId] + ".chunk.js");